import { graphql } from 'gatsby'
import React from 'react'
import SEO from '../components/shared/Seo'
import HeroImage from '../components/HeroBackground/HeroImage/HeroImage'
import loadable from '@loadable/component'
import Seo from '../components/seo'
import { useUrl } from '../hooks/layout/useUrl'
// const SectionFeature = loadable(()=>import('../components/SectionFeature/SectionFeature'))
import SectionFeature from "../components/SectionFeature/SectionFeature"
import DirectDownload from '../components/DirectDownload/DirectDownload'
const HomePage = ({
    location,
    pageContext,
    data: {
        contentfulEkaterraHomePage: {
            title,
            slug,
            node_locale,
            seoTitle,
            seoDescription,
            sections
        },
        allContentfulEkaterraHomePage: {
            nodes
        }
    }
}) => {
    const lang = useUrl()
    return (
        <>
            <Seo
                slug={slug}
                title={seoTitle}
                description={seoDescription && seoDescription.seoDescription}
                node_locale={node_locale}
                lang={lang}
                hreflangs={nodes}
                content = {true}
            />
            {
                sections.map((section: any, key: number) => {
                    //console.log(section.__typename,section.__typename==='ContentfulSectionComponentHero');

                    switch (section.__typename) {
                        case 'ContentfulSectionComponentHero':
                            return (
                                <HeroImage
                                    data={section} key={key}
                                />
                            )
                        case 'ContentfulComponentFeature':
                            return (
                                <SectionFeature
                                    data={section}
                                    home='true'
                                    key={key}
                                />
                            )
                        case "ContentfulComponentDocumentDownload":
                            return section.title && (
                                <DirectDownload data={section} key={key} />
                            )
                        default:
                            return null
                    }
                })
            }
        </>
    )
}
export const HomePageQuery = graphql`
    query EkaterraHomePage($id:String!, $contentful_id: String! ){
        contentfulEkaterraHomePage(id:{eq:$id}){
            title
            seoTitle
            node_locale
            seoDescription {
                seoDescription
            }
            slug
            sections {
                __typename
                ...homeReleaseDoc
                ... on ContentfulSectionComponentHero {
                    id
                    name
                    title
                    image {
                        gatsbyImageData
                        title
                    }
                    mobileImage {
                        gatsbyImageData
                        title
                    }
                    
                }
                ... on ContentfulComponentFeature {
                    id
                    name
                    title
                    appearance
                    headingLevel
                    isColumnLayout
                    descriptionType
                    alignment
                    description {
                        raw
                    }
                    button {
                        link
                        title
                    }
                    images {
                        gatsbyImageData
                        title
                    }
                    backgroundImage {
                        gatsbyImageData
                        title
                    }
                }
            }
        }
        allContentfulEkaterraHomePage(filter: {contentful_id: {eq: $contentful_id}, id: {ne: $id}}){
            nodes {
                slug
                node_locale
            }
        }
    }
`
export default HomePage